//User

export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

//Global

export const QUERY_IS_LOADING = 'QUERY_IS_LOADING';
export const QUERY_NOT_LOADING = 'QUERY_NOT_LOADING';
export const REQUEST_BANNERS = 'REQUEST_BANNERS';
export const REQUEST_EVENTS = 'REQUEST_EVENTS';
export const REQUEST_FILTERS = 'REQUEST_FILTERS';

//Initiative

export const INITIATIVE_SET_PATH_REQUEST = 'INITIATIVE_SET_PATH_REQUEST';
export const INITIATIVE_SET_INITIATIVE_CLICKED = 'INITIATIVE_SET_INITIATIVE_CLICKED';
export const INITIATIVE_SET_SHOW_PURPOSE = 'INITIATIVE_SET_SHOW_PURPOSE';